
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';


export function getResetPasswordDtoFormGroup() {
return new FormGroup({
    username: new FormControl<string | undefined>('', [Validators.required]),
    token: new FormControl<string | undefined>('', [Validators.required]),
    password: new FormControl<string | undefined>('', [Validators.required]),
})
;
}
      